import { config } from "../config";
import { Button, Card, CardContent, Grid } from "@mui/material";
import { ConfirmDangerModalComponent, IDType } from "@soqs/common";
import {
  formState,
  updateFormState,
  currentPage,
  setPage,
  submitFormAsync,
} from "../features/AppSlice";

import React, { useMemo, useState } from "react";
import { Form, FormSpy } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import createDecorator from "final-form-calculate";
import EnterFraudDetails from "./EnterDetailsComponents/EnterFraudDetails";
import FraudInformation from "./EnterDetailsComponents/FraudInformation";

import arrayMutators from "final-form-arrays";
import { initial } from "lodash";

const EnterDetails = (_props) => {
  const dispatch = useDispatch();
  const wizardPage = useSelector(currentPage);
  const setWizardPage = (newPage) => {
    dispatch(setPage(newPage));
  };
  const [confirmClearModal, setConfirmClearModal] = useState(false);

  const getInitials = (name) => {
    if (!name) {
      return undefined;
    }
    return name
      .split(" ")
      .filter((x) => x !== "")
      .reduce((acc, curr) => {
        return acc + curr[0];
      }, "")
      .toUpperCase()
      .slice(0, 4);
  };

  const setInitials = useMemo(
    () =>
      createDecorator({
        field: "name",
        updates: {
          initials: (name, allValues, prevValues) => {
            //Lockout update when initials does not match name any more
            if (
              prevValues &&
              getInitials(prevValues.name) === prevValues.initials
            ) {
              return getInitials(name);
            } else {
              return allValues.initials;
            }
          },
        },
      }),
    []
  );

  const initV = {
    q_contactdetails: "no",
    idtype: IDType.RSA_Id,
  };
  const reduxFormState = useSelector(formState);
  const prefilledState = useMemo(() => reduxFormState?.values ?? initV, []);

  return (
    <Form
      onSubmit={async () => {
        switch (wizardPage) {
          case 1: {
            await dispatch(submitFormAsync());
            break;
          }

          default: {
            window.scrollTo(0, 0);
            setWizardPage(wizardPage + 1);
          }
        }
      }}
      decorators={[setInitials]}
      initialValues={prefilledState}
      mutators={{ ...arrayMutators }}
    >
      {({ handleSubmit, submitting, _pristine, values, form, _errors }) => (
        <>
          <Grid container spacing={2} direction="column">
            <FormSpy
              onChange={(state) => {
                dispatch(updateFormState(state));
              }}
            />
            <Wizard page={wizardPage} />

            <Grid size={{ xs: 12 }}>
              <Card>
                <CardContent>
                  <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                          if (wizardPage === 0) {
                            setConfirmClearModal(true);
                          } else {
                            setWizardPage(wizardPage - 1);
                          }
                        }}
                      >
                        {wizardPage === 0 ? "Reset Form" : "Back"}
                      </Button>
                    </Grid>
                    <Grid>
                      {config.ENVIRONMENT === "development" ? (
                        <Button
                          id="continue-to-upload"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            dispatch(submitFormAsync());
                          }}
                          loading={submitting}
                        >
                          Continue to Upload (No FE validation)
                        </Button>
                      ) : null}
                      <Button
                        id="continue-to-upload"
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        loading={submitting}
                      >
                        Next
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <ConfirmDangerModalComponent
            open={confirmClearModal}
            onClose={() => {
              setConfirmClearModal(false);
            }}
            cbConfirm={() => {
              form.restart(initV);
              setConfirmClearModal(false);
            }}
            title="Reset form"
            subheader="Are you sure you want to clear the form?"
            confirmText="Clear"
          />
          {config.ENVIRONMENT === "development" ||
          config.ENVIRONMENT === "qadebug" ? (
            <pre>{JSON.stringify(values, null, 2)}</pre>
          ) : (
            <></>
          )}
        </>
      )}
    </Form>
  );
};
const Wizard = ({ page }) => {
  switch (page) {
    case 0: {
      return <EnterFraudDetails />;
    }
    case 1: {
      return <FraudInformation />;
    }
    default:
      return <></>;
  }
};
export default EnterDetails;
